module.exports = __webpack_public_path__ + "img/linkedin.9d4d435a.png";